module.exports = __webpack_public_path__ + "img/referenti-alertmsg.2a011f83.png";